import { QueryClient } from '@tanstack/react-query'

import { getChain } from '~/constants/chains'
import { getChainLabel } from '~/utils/chainLabels'

/**
 * Categorize missing chain IDs into those unsupported by Teams vs those just not enabled on the org
 * @param missingChainIds - Chain IDs that are missing/not available
 * @param queryClient - Optional React Query client for relay network lookups
 * @returns Categorized chain IDs and their formatted names
 */
export const categorizeMissingChains = (
  missingChainIds: number[],
  queryClient?: QueryClient,
) => {
  const unsupportedByTeamsChainIds = missingChainIds.filter(
    (id) => !getChain(id),
  )
  const notEnabledOnOrgChainIds = missingChainIds.filter((id) => !!getChain(id))

  const unsupportedByTeamsChainNames = unsupportedByTeamsChainIds.map((id) =>
    getChainLabel(id, { queryClient }),
  )
  const notEnabledOnOrgChainNames = notEnabledOnOrgChainIds.map((id) =>
    getChainLabel(id),
  )

  return {
    unsupportedByTeamsChainIds,
    notEnabledOnOrgChainIds,
    unsupportedByTeamsChainNames,
    notEnabledOnOrgChainNames,
    hasUnsupportedByTeamsChains: unsupportedByTeamsChainIds.length > 0,
    hasNotEnabledOnOrgChains: notEnabledOnOrgChainIds.length > 0,
  }
}
